import React from "react";
import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function Index(props) {
  const theme = createTheme({
    palette: {
      primary: { main: "#ff5722" },
    },
  });

  return (
    <div
      component="main"
      style={{
        flexGrow: 1,
        overflow: "hidden",
      }}
      mt={4}
    >
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            backgroundImage:
              localStorage.getItem("kowalskiMode") === "true"
                ? "url(./img/kowalski.png)"
                : localStorage.getItem("darkMode") === "true"
                ? "url(./img/bg_ini.png)"
                : "url(./img/bg_ini_light.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            width: "80%",

            top: 10,
            bottom: 10,
            position: "fixed",
            bgcolor: "background.default",
            color: "text.primary",
          }}
        ></Box>
      </Box>
    </div>
  );
}
